import axios, { AxiosError, AxiosInstance } from "axios";

const baseURL = process.env.REACT_APP_API_URL;

export const apiInstance: AxiosInstance = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

// middle ware xử lý thêm token trước khi gửi đi request
apiInstance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token"); // Lấy token từ localStorage hoặc nguồn khác
    if (token) {
      config.headers.Authorization = `Bearer ${token}`; // Thêm Authorization header
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const handleApiError = (error: AxiosError) => {
  // Only log in development
  if (process.env.NODE_ENV === 'development') {
    console.error('API Error:', error.response?.status, error.message);
  }
  throw error.response?.data || error?.message;
};
